import React from 'react';
import {observer} from "mobx-react";
import {GameInfo} from '../../../../../../services/games/game-info';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';
import {LiveStreamSlidePlayerContainer} from '../../../live-stream/player/boxes/live-stream-slide-player-container.box';
import {IVideoPlayerViewModel} from "../../../../../../services/video/models/video-player.view-model.interface";
import {VideoPlayerComponent} from "../../../../../video-player/video-player.component";
import {VideoSlidePlayerSkeletonBox} from "../../../../parts/skeleton/video-slide-player-skeleton.box";
import {VideoTypeEnum} from "../../../../../../services/video/models/video-type.enum";


interface VideoStreamSlidePlayerComponentProps {
    gameInfo: GameInfo;
    videoPlayer: IVideoPlayerViewModel;
    isActive: boolean;
}

export const VideoStreamSlidePlayerComponent: React.FC<VideoStreamSlidePlayerComponentProps> = observer((props) => {

    const showSkeleton = props.videoPlayer.isLoading && !props.videoPlayer.isPosterLoaded && !props.videoPlayer.hasError;

    return (        
        <>
            <FlexGrowItemBox />
            {showSkeleton && <VideoSlidePlayerSkeletonBox/>}
            <LiveStreamSlidePlayerContainer style={{display: showSkeleton ? 'none' : 'block'}} className={`cy-video-slide-game-${props.gameInfo.gameType}`}>
                <VideoPlayerComponent videoPlayer={props.videoPlayer}
                                      src={props.gameInfo.videoSlideUrl}
                                      isActive={props.isActive}
                                      videoType={VideoTypeEnum.VideoStream}
                                      poster={props.gameInfo.slideCover}/>
            </LiveStreamSlidePlayerContainer>
            <FlexGrowItemBox />
        </>
    )
});
